import * as React from 'react'
// libs
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// components
import { ReduxInput, ReduxSelect } from 'components/FormElements/ReduxForm'
// constants
import { Forms } from 'constants/index'
import { REVIEW_REPEAT_OPTIONS, REVIEW_REPEAT_VALUES, REVIEW_TYPE_OPTIONS } from 'constants/review'
// utils
import { getRepeatingReviewDueDate } from 'utils/reviews'
import { getValueFromOption, positive, required } from 'utils/index'
// themes
import { colors } from 'themes'

// styled
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 48%;

  > span {
    color: ${colors.gray400};
    font-size: 12px;
  }
`

const Container = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 12px;

  > div {
    flex: 1;
  }
`

interface IProps {
  form?: string
}

export const FirstReviewEndsDate: React.FC<IProps> = ({ form = Forms.SCHEDULE_REVIEW_FORM }) => {
  const selector = formValueSelector(form)

  const { endPeriod, end, value, period } = useSelector((state) => ({
    endPeriod: selector(state, 'firstPeriodEndsAt'),
    end: getValueFromOption(selector(state, 'end')),
    value: selector(state, 'value'),
    period: getValueFromOption(selector(state, 'period'))
  }))

  const shouldShowDueDate = (endPeriod && end === REVIEW_REPEAT_VALUES.END) || (endPeriod && value && period)

  return (
    <>
      <Wrapper>
        <ReduxSelect label={'Period'} name={'end'} options={REVIEW_REPEAT_OPTIONS} validate={[required]} />

        {end && end !== REVIEW_REPEAT_VALUES.END && (
          <Container>
            <ReduxInput name={'value'} type={'number'} validate={[positive, required]} />
            <ReduxSelect name={'period'} options={REVIEW_TYPE_OPTIONS} validate={[required]} />
          </Container>
        )}
        <span>
          {shouldShowDueDate &&
            `Review due by ${getRepeatingReviewDueDate({
              endPeriod,
              end,
              value,
              period
            }).format('D MMM Y')}`}
        </span>
      </Wrapper>
    </>
  )
}

export default FirstReviewEndsDate
